module.exports = __webpack_public_path__ + "img/easy_rent_a_car2.578feff4.jpg";